module.exports = __webpack_public_path__ + "media/images/front/brands/avant_garde/avant_garde_header_2-56964cab71ecba67a2f685fde01501d1.webp";